<template>
    <main-section>
        <template #tit>파트너 <span class="primary--text">가입 절차</span></template>
        <template #txt>가입하기 전 파트너 등록 자격 요건이나 사전 준비사항을 미리 확인하세요!</template>

        <membership-steps />
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";
import MembershipSteps from "../dumb/membership-steps.vue";

export default {
    components: {
        MainSection,
        MembershipSteps,
    },
};
</script>